module.exports = "https://www.gc-qa.gnp.com.mx/a6b2215c1ff5331f3ef2807adcc5cd7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/capitaliza/1.png
// module id = 1014
// module chunks = 0 1